import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { createEvent as createEventApi } from "../api/event.api";
import type { CreateEventForAdminRequest, EventItemResponse } from "../types/event.types";

interface UseCreateEventReturn {
  createEvent: (request: CreateEventForAdminRequest) => Promise<EventItemResponse>;
  loading: boolean;
  error: string | null;
}

export const useCreateEvent = (): UseCreateEventReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createEvent = useCallback(
    async (request: CreateEventForAdminRequest): Promise<EventItemResponse> => {
      try {
        setLoading(true);
        setError(null);
        return await createEventApi(request);
      } catch (createError: unknown) {
        setError(getApiErrorMessage(createError, "Failed to create event"));
        throw createError;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { createEvent, loading, error };
};
